
<template>
    <div id="dot" style="display: flex;
    margin-bottom: -15px;">
    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle" class="svg-inline--fa fa-circle fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg"  width="14" height="16"  viewBox="0 0 512 512"><path fill="#005A06" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"></path></svg>
    </div>

</template>

<script>
export default {
  name: 'icon',
  components:{
  },

}
  </script>